<!-- ================:=========================================================================
  File Name: EditCourse.vue
  Description: User Edit Page

========================================================================================== -->

<template>
  <div id="course-new">
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Details" icon-pack="feather" icon="icon-edit">
            <div class="tab-text">
              <lab-details-tab :data="lab_data" v-on:update_lab_data="labDataUpdate" v-on:insert_lab_data="create_lab" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import LabDetailsTab from './AccountDetailsTab.vue'
import axios from 'axios'

export default {
  components: {
    LabDetailsTab
  },
  data () {
    return {
      lab_data: {
        pool: undefined,
        username: undefined,
        password: undefined
      },

      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      //tab change
    }
  },
  methods: {
    labDataUpdate (data) {
      this.lab_data = data
    },
    create_lab () {
      this.$vs.loading()

      axios
        .post(`${process.env.VUE_APP_ROOT_LABS_API}/labs/accounts`, this.lab_data)
        .then((response) => {
          this.$vs.loading.close()

          this.$vs.notify({
            title: 'Created account successfully',
            text: 'New account has been created.',
            color: 'success',
            position: 'top-right'
          })

          if (response.status === 200) {
            const data = response.data
            this.$router.push(`/a/labs/accounts/${data.id}`)
          }
        })
        .catch((exception) => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while creating this account'
          if (exception.response) {
            error = exception.response.data.message
          }

          return this.$vs.notify({
            title: 'Failed to create account',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    }
  }
}
</script>
